<template>
  <!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
  <b-icon
    :pack="pack"
    :size="size"
    :custom-class="customClass"
    :type="type"
    :icon="icon"
    @click.native="handleClick"
  />
  <!-- eslint-enable vue/no-deprecated-v-on-native-modifier -->
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'IconView',
  emits: ['click'],
  props: {
    icon: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Object]
    },
    pack: {
      type: String,
      default: 'cls'
    },
    size: {
      type: String
    },
    customClass: {
      type: String
    }
  },
  methods: {
    handleClick(...args) {
      this.$emit('click', ...args);
    }
  }
};
</script>
